<template>
    <div v-show="fisimed" class="container-component">
        <div class="component">
                <select v-model="selectedOption">
                    <option value="">--Choisissez vos options--</option>
                    <option v-for="option in options" :value="option">{{ option }}</option>
                </select>

                <div class="container-btnEditPatient">
                    
                    <button class="width-cent" v-on:click="formulaireNouveau">Nouveau </button>
                    <button v-if="selectedOption === 'Modifier'" class="width-cent" @click="modif">Modifier</button>

                    <button class="width-cent">Suite</button>
                </div>
                <div class="container-recherche-bar">
                    <label class="width-cent"></label>
                    <input id="recherche-bar" class="width-cent" v-model="critere" v-on:keyup="chercher()" />
                    <button class="width-cent" v-on:click="chercher()">Chercher</button>
                </div>
                <div class="tableRecherche-container">
                    <table>
                        <thead>
                            <tr class="teteTableau">
                                <th class="row-table" v-on:click="commencerLeTrie(uneCle)" v-for="uneCle in lesCles">{{uneCle}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="row-table" v-for="unPatient in lesPatientsTries" v-bind:key="unPatient.Key" v-on:click="envoyerPatientCourant(unPatient)">
                                <td data-label="Nom">{{unPatient.Value.Nom}}</td>
                                <td data-label="Prénom">{{unPatient.Value.Prenom}}</td>
                                <td class="CodePostal" data-label="Code Postale">{{unPatient.Value.CodePostal}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
</template>
<style scoped>
    * {
        font-family: arial;
        margin: 0;
    }

    .container-component {
        margin-left: 20px;
        background-color: #00BFFF;
        border-radius: 30px;
        width: 700px;
        height: 300px;
        border-bottom-left-radius: unset;
        border-bottom-right-radius: unset;
    }

    .container-btnEditPatient, .container-recherche-bar {
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: center;
       
    }

    .container-btnEditPatient > button {
        display: flex;
        justify-content: center; /* Centrer horizontalement */
        align-items: center; /* Centrer verticalement */
        background-color: white;
        border-radius: 10px;
        border: hidden;
        width: 200px;
        height: auto;
        text-align: center;
        padding: 10px;
        margin: 10px;
        font-size: medium;
    }

    .width-cent {
        width: 30%;
        height: auto;
    }

    #recherche-bar {
        width: 100%;
        height: 40px;
        border-radius: 15px;
        padding: 10px;
        background-color: #eaf2fb; /* couleur de fond */
        color: #2a5f95; /* couleur du texte saisi */
    }

    .teteTableau > th {
        cursor: pointer;
        position: sticky;
        top: 0px;
        background-color: #2a5f95;
    }

    .tableRecherche-container {
        font-size: 16px;
        overflow-y: scroll;
        border-radius: unset;
        background-color: white;
        color: black;
        height:730px;
       
        
    }
    button.width-cent {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        border-radius: 10px;
        border: hidden;
        margin: 10px;
        font-size: medium;
    }
    th {
        border: 0.1px black solid;
        cursor: pointer;
        color: white;
        text-align: center;
        background-color:darkblue;
        
    }
    .row-table {
        cursor: pointer;
        width: 400px;
        height: 25px;
        text-align: center;
        cursor: pointer;
    }
    tbody .row-table:hover {
        background: #e4e8ff;
    }
    th:hover {
        background-color: lightblue;
    }
    @media screen and (max-width: 600px) {
        .container-component {
            width: 280px;
            height: 100px;
        }

        .row-table {
   
            width: 150px;
            height: 25px;
        }
        .container-btnEditPatient > button {
            
            border-radius: 5px;
            width: 150px;
            height: 20px;
            padding: 10px;
            margin: 10px;
        }
        #recherche-bar {
            height: 15px;
          
            margin: 8px;
        }
    
    }
</style>
<script>
    import { isProxy, toRaw } from 'vue';
    import { defineComponent } from 'vue';
    import Patient from '../script/Patient.js';
    export default defineComponent({
        data: function () {
            
            let d = {
                message: "Salut salut",
                teste: "Je suis un teste",
                fisimed: true,
                lesCles: ["Nom", "Prenom", "CodePostal"],
                cleDeTrie: 'Nom',
                ok: true,
                critere: "",
                fonctionCherche: false,
                lesPatientsCherches: null,
                selectedOption: "",
                options: ['Modifier en temps réel', 'Modifier']
            }
            var ordreTri = {};
            d.lesCles.forEach(function (uneCle) {
                ordreTri[uneCle] = 1; 
            });

            d['ordreTri'] = ordreTri;
            return d;
        },
        

        computed: {
            lesPatientsBis: function () {
                console.log('On est dans la fonction!');
                if (!this.lesPatients) {
                    return null
                }
                else {
                    return this.sortBy();
                }
            },

            lesPatientsTries: function () {
                return this.sortBy()
            },
            patientCourant() {
                return this.$store.getters["ConnexionStore/getPatientCourant"]
            }
        },
        props: ["Nom", "tab", 'obj', "lesPatients","modifEnTempsReel"]
        ,
        created() {
            /*this.$watch('patientCourant', this.patientCourantHasChanged, { deep: true });*/
        },
        watch: {
            selectedOption(newValue, oldValue) {
                var condModifEnTempsReel = this.selectedOption === 'Modifier en temps réel';
                this.$emit("setModifEnTempsReel", condModifEnTempsReel)
            }
        },
        methods: {
            patientCourantHasChanged() {
                if (this.selectedOption === 'Modifier en temps réel') {
                    this.modifSouris();
                }
            },
            //CECI est une méthode pour tester les objets Proxy (en l'occurence ici, c'est lesPatients qui peut être un Objet de tupe proxy)
            formulaireNouveau() {
                console.log("tu modif");//test pour le click
                this.$router.push('/SaisieUtilisateur');
            },
            modif() {
                console.log("tu modif");//test pour le click
                this.$router.push('/ModifierPatient');
            },
            ZOOM() {
                console.log();
                console.log(this.lesPatients);
                if (isProxy(this.lesPatients)) {
                    var raw = toRaw(this.lesPatients);
                    console.log(raw[0]);
                }
            },
            modifSouris() {
                Patient.modifierPatient(this.patientCourant);
            },
            sortBy() {
                var uneCle = this.cleDeTrie;
                var p = this.lesPatients;
                if (p != null && Array.isArray(p)) {
                    var ordreTri = -this.ordreTri[uneCle];
                    p = p.slice().sort(function (a, b) {
                        a = a['Value'][uneCle];
                        b = b['Value'][uneCle];
                        return (a === b ? 0 : a > b ? 1 : -1) * ordreTri;
                    });
                    return p;
                }
                else
                    return [];
                
                //console.log(p[0].value.nom);
            },
            envoyerPatientCourant(unPatient) {
                this.$emit('setPatientCourant', unPatient);
            },
            envoyerLesPatientsCourants() {
                this.$emit('setPatientCourant', this.lesPatientsCherches);
            },

            commencerLeTrie(uneCle) {
                this.cleDeTrie = uneCle;
                this.ordreTri[uneCle] *= -1;
            },

            sort(a, b) {
                return a.toString().localeCompare(b.toString);
            },

            strSort(a) {
                return a.sort(function (x, y) {
                return x.toString().localeCompare(y.toString());
                });
            },

            chercher() {
                this.fonctionCherche = true;
                /*input.value="Salut salut ça va?"*/
                /*alert("critere.value=" + this.critere); // $refs.critere.value);*/
                //fetch('https://localhost:5001/Patient/chercher?critere=' + this.critere)
                //    .then(r => r.json())
                //    .then(json => {
                //        this.lesPatientsCherches = json;
                //        this.$emit('setLesPatients', json);
                //        console.log(json);
                //        /*alert("Voici la liste mon gars");*/
                //        //return this.lesPatients;
                //        this.fonctionCherche = false;
                //        return json;
                //    });

                this.$emit('setLesPatients', this.critere);
            }

            ///min(uneCle,)


            
        },
        
        mouted: function(){
            this.message = this.start;
        }
        
    });
</script>

